import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Standings} from "../../../models/standings";
import {Utils} from "../../utils";
import {NbDialogService, NbIconModule} from "@nebular/theme";
import {StandingsFormComponent} from "../standings-form/standings-form.component";
import {DecimalPipe} from "@angular/common";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-standings-table',
  standalone: true,
  imports: [
    TranslateModule,
    NbIconModule,
    DecimalPipe
  ],
  templateUrl: './standings-table.component.html',
  styleUrl: './standings-table.component.scss'
})
export class StandingsTableComponent {
  @Input() standingsList!: Standings[];
  @Input() editable!: boolean;
  @Output() onRefreshList = new EventEmitter<boolean>();

  constructor(public utils: Utils, private dialogService: NbDialogService) {}

  edit(param: any) {
    this.dialogService.open(StandingsFormComponent, {
      context: {
        standings_id: param.standings_id,
        group_id: param.group_id,
        division_id: param.division_id,
        team_id: param.team_id,
      },
    }).onClose.subscribe(() => this.onRefreshList.emit(true));
  }
}
